var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    { attrs: { bottom: "" } },
    [
      _c("template", { slot: "activator" }, [
        _c(
          "i",
          {
            staticClass: "primary--text",
            staticStyle: {
              "font-weight": "600",
              "font-size": "x-small",
              "margin-right": "10px",
              "padding-top": "10px"
            }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.coTime)),
            _vm.displayStatus && !_vm.displayAllDone
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "primary" }
                  },
                  [_vm._v("done")]
                )
              : _vm.displayStatus && _vm.displayAllDone
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "primary" }
                  },
                  [_vm._v("done_all")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.source.notifications, function(notif) {
        return _c(
          "div",
          [
            _vm._v("\n    " + _vm._s(notif.fullname) + "\n    "),
            notif.is_watched
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("done_all")]
                )
              : _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("done")]
                ),
            _vm._v(" "),
            notif.trackingEmailState === "Delivery"
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("mark_email_unread")]
                )
              : notif.trackingEmailState === "Bounce"
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("unsubscribe")]
                )
              : notif.trackingEmailState === "Open"
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("drafts")]
                )
              : _vm._e(),
            _vm._v(" "),
            notif.send_by_sms
              ? _c(
                  "v-icon",
                  {
                    staticClass: "ml-1",
                    staticStyle: { display: "inline-block" },
                    attrs: { small: "", color: "white" }
                  },
                  [_vm._v("mobile_friendly\n    ")]
                )
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98f89c5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98f89c5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message-time-notif-status/template.html
// module id = null
// module chunks = 